import LinkTab from '../components/shared-components/link_tab';
import React from 'react';
import { connect } from 'react-redux';
import { setInfo, setGameData } from '../redux/actionList';

import withRouterCompat from '../objects/CommonUse/with_router_compat';
import {Link} from "react-router-dom";
import {Tooltip} from "@mui/material";
import ExtraCreditMain from '../components/extra_credit/extra_credit_main';
import Level1Challenges from '../components/extra_credit/level1_challenges';
import Level2Challenges from '../components/extra_credit/level2_challenges';
import MoneyCalculators from '../components/extra_credit/money_calculators';
import CommentModal from '../components/shared-components/comment_modal';
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import ExtraCreditConfigFile from '../components/extra_credit/Datasets/extra_credit_config_file';
import MoneyMgmtConceptTest from '../components/extra_credit/money_mgmt_concept_test';
import ConfigFile from '../datasets/config_file';
import Footer from './footer';
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import { createTaxAmtExpense } from '../objects/AssetsExpenses/create_tax_amt_expense';
import { addChangeSalaryAsset } from '../objects/AssetsExpenses/add_change_salary_asset';
import {buildUrl } from '../objects/CommonUse/build_URL';
import Config from '../config';
import WaitTimeSpinner from '../components/shared-components/wait_time_spinner';
import determineIfAllExtraCreditComplete from '../components/extra_credit/objects/determine_if_all_extra_credit_complete';
import tooltipCommentIconText from './Text/tooltip_text';
import beforeAfterCompare from '../objects/CommonUse/before_after_compare';
import createEventTrackerUpdateObject from '../objects/CommonUse/create_eventTracker_update_object';
import TaxChangeEventTracker from '../datasets/tax_change_event_tracker';
import updateSessionTokenStorage from './Objects/update_session_token_storage';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    timeWizardInfo: state.timeWizardInfo,
    extraCreditExists: state.extraCreditExists
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    setGameDataRedux: setGameData
};

class ExtraCredit extends React.Component {
    constructor(props) {
        super(props);
      
    this.openCommentModal = this.openCommentModal.bind(this);
    this.closeCommentModal = this.closeCommentModal.bind(this);
    this.gameInfo = JSON.parse(JSON.stringify(this.props.gameInfo));
    this.gameData = JSON.parse(JSON.stringify(this.props.gameData));
    this.timeWizardInfo = JSON.parse(JSON.stringify(this.props.timeWizardInfo))

     this.state = {
        inputArr: [
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
        ],
        headers: setHeadersForFetch(),
        doneLoading: false,
        data: null,
        eventArr: [],
        eventCount: 0,
        eventTracker: ConfigFile.general.eventTracker,
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "ExtraCredit",
        screenSize: sessionStorage.getItem("GameScreenSize"),
        prevMatches: null, 
        environment: Config.dataURL.currentEnv,
        subProcess: "extraCredit",
        gameDataLoading: true,
        timeWizardLoading: true,
        extraCreditLoading: true,
        archivedGameLoaded: true,
        gameInfo: {},
    };

    switch(props.selected) {
        case "extraCreditMain":
            this.inputSelected(0);
            break;
        case "level1Challenges":
            this.inputSelected(1);
            break;
        case "level2Challenges":
            this.inputSelected(2);
            break;
        case "moneyCalculators":
            this.inputSelected(3);
            break;
        case "moneyMgmtTest":
            this.inputSelected(4);
            break;
        default:
            break;
        }
        this.openModal = true;
        this.exerciseLevelArr = [];
        this.extraCreditCompleted = [];
        this.currentGameMonths = 0;
        this.extraCreditObj = {};
        this.totalNbrGameMonths = +ConfigFile.gameStartItems.totalNbrGameMonths;
        this.allExtraCreditComplete = false;
    }

    saveTestResults(){
        // this will eventually move to the actual test page
    }
    
    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

    render(){
        if (this.state.timeWizardLoading === false){
            this.totalGameMonthsPlayed = +this.currentGameMonths + +this.previousGameMonths;
        }
        this.gameInfoDisplay = this.state.gameInfo;
        if (this.selected !== this.props.selected){
            updateSessionTokenStorage(this.props.selected);
            this.selected = this.props.selected;
        }
          
    return <>
        <span className="container m-0 p-0">
        {this.state.gameDataLoading || this.props.extraCreditExists === null 
            || this.state.timeWizardLoading ?
                <div className="mt-5">
                        <WaitTimeSpinner/>  
                </div>
            :
            <span className="row w-100 mx-0">
                
                    <div className="col-sm-2 mt-4">
                        <div>
                            <img className="train-track-img" src={'./assets/ExtraCredit.png'} 
                                alt="MoneyTrain"/>
                        </div>   
                    </div>
                
                    <div>
                        <Tooltip title={tooltipCommentIconText} arrow>
                            <img src={this.state.commentIcon} 
                                className={this.commentIconClass} alt="comment"
                                onClick={this.openCommentModal}/>
                        </Tooltip>
                    </div>

                    {this.state.commentModalOpen ?
                        <CommentModal modalOpen={this.state.commentModalOpen} 
                            onClose={() => this.closeCommentModal()}
                            gamePart={this.state.fromProcessName}
                            processName={this.props.selected}
                            gameInfo = {() => this.getGameInfo()}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    :
                        null
                    }

                    {this.props.selected === "extraCreditMain" ? 
                        <ExtraCreditMain 
                            playerRole = {this.gameInfoDisplay.playerRole}
                            onOpen ={()=> this.inputSelected(0)} 
                            gameInfo = {() => this.getGameInfo()} 
                            goBack = {() => this.goToHomePage()}
                            onNavigate={(pathname) => this.onNavigate(pathname)}
                            setGameInfo = {(value, propertyName) => this.setGameInfo(value, propertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            /> 
                        : <span/>}
                   
                    {this.props.selected === "level1Challenges"? 
                        <Level1Challenges
                            extraCreditCompleted={this.exerciseLevelArr}
                            onOpen ={()=> this.inputSelected(1)}
                            completed={() => this.inputCompleted(1)} 
                            goBack = {() => this.goToHomePage()}
                            updateAmounts={() => this.updateAmounts()}
                            onNavigate={(pathname) => this.onNavigate(pathname)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        :<span/>}
                         
                    {this.props.selected === "level2Challenges"? 
                        <Level2Challenges
                            goBack = {() => this.goToHomePage()}
                            extraCreditCompleted={this.exerciseLevelArr}
                            onOpen ={()=> this.inputSelected(2)}
                            completed={() => this.inputCompleted(2)} 
                            updateAmounts={() => this.updateAmounts()}
                            onNavigate={(pathname) => this.onNavigate(pathname)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        :<span/>}

                        {this.props.selected === "moneyCalculators" ? 
                            <MoneyCalculators
                                goBack = {() => this.goToHomePage()}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                        :<span/>}
                                              
                    {this.props.selected === "moneyMgmtTest" ? 
                        <MoneyMgmtConceptTest
                            totalGameMonthsPlayed={this.totalGameMonthsPlayed}
                            nbrGames={this.nbrGames}
                            goBack = {() => this.goToHomePage()}
                            completed={() => this.inputCompleted(3)} 
                            onNavigate={(pathname) => this.onNavigate(pathname)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        :<span/>}


                    {this.gameInfoDisplay.loading  && this.gameInfoDisplay.playerRole !== null ?
                                null
                            :
                            <div className="col-sm-2"> 
                                <Link to="/extra-credit-main" onClick={() => this.handleClick(0)}>
                                    <LinkTab inputArr={this.state.inputArr[0]} name="Main Page" 
                                        validToComplete="true"
                                    />
                                </Link>

                            {this.state.inputArr[1].completed  ?
                                <LinkTab inputArr={this.state.inputArr[1]} name="Level 1 Challenges"  
                                 />   
                            :
                                <Link to="/level1-challenges" onClick={() => this.handleClick(1)}>
                                    <LinkTab inputArr={this.state.inputArr[1]} name="Level 1 Challenges" 
                                        validToComplete="true"
                                       />
                                </Link>
                            }
                       
                            {this.state.inputArr[2].completed === true  ?
                                <LinkTab inputArr={this.state.inputArr[2]} name="Level 2 Challenges"
                                />
                                :
                                <Link to="/level2-challenges" onClick={() => this.handleClick(2)}>
                                    <LinkTab inputArr={this.state.inputArr[2]} name="Level 2 Challenges" 
                                        validToComplete="true"
                                      />
                                </Link>
                            }
                             
                             <Link to="/money-calculators" onClick={() => this.handleClick(3)}>
                                <LinkTab inputArr={this.state.inputArr[3]} name="Money Calculators" 
                                    validToComplete="true"
                                    />
                            </Link>

                            <Link to="/money-mgmt-test" onClick={() => this.handleClick(4)}>
                                <LinkTab inputArr={this.state.inputArr[4]} name="Are You Financially Savvy?" 
                                    validToComplete="true"
                                />
                            </Link>
                            {( this.state.screenSize === "zoom") &&
                                <Footer 
                                    screenSize={this.state.screenSize}
                                />
                            }            
                        </div>
                    }  

    {/*
                 {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
                </span>
            }
            </span>
                       
    </>
}

componentDidMount(){
    this._isMounted = true;
    this.className = "mt-5 mx-3";
    if (this.state.screenSize === "ipad" ||
        this.state.screenSize === "zoom"
    ){
        this.commentIconClass = "comment-icon-position comment-img";
    }else{
        this.commentIconClass = "extra-credit-comment-icon-position comment-img"; 
    }
    this.userRole = sessionStorage.getItem("userRole");
    this.loadGame();
    this.loadExtraCredit();
}


inputSelected = (inputID) => {
    let inputArr = this.state.inputArr;
    for (const input of inputArr) {
        input.selected = false;
    }
    inputArr[inputID].selected = true;
    if (this._isMounted === true){
        this.setState({inputArr: inputArr});
    }  
};

inputCompleted = (inputID) => {
    let inputArr = this.state.inputArr;
    inputArr[inputID].completed = true;
    this.setState({inputArr: inputArr}); 
};

componentWillUnmount(){
    this.setGameInfo("extra-credit-main", "prevProcess");
}

openCommentModal(){
    this.setState({commentModalOpen: true});
}

closeCommentModal(){
    this.setState({commentModalOpen: false});
}

handleClick = index => {
    this.inputSelected(index);
    this.index = index;
}

async loadGame()
{
    if (this._isMounted === true){
        this.setState({gameDataLoading: false});
    }
    if (this._isMounted === true){
        this.setState({gameInfo: this.props.gameInfo});
    }
    this.currentGameMonths = 0;
    this.previousGameMonths = 0;
    this.nbrGames = 0;
    if (this.gameData.gameNbrMonths){
        this.gameNbrMonths = this.gameData.gameNbrMonths;
        this.previousGameMonths = this.gameData.prevGameMonths;
        this.nbrGames = +this.gameData.prevNbrGames;
        if (!this.timeWizardInfo.gameID){
            this.loadTimeWizard(this.gameData._id);
        }else{
            this.determineCurrentNbrGameMonths(this.timeWizardInfo);
            this.setState({timeWizardLoading: false});
        }
    }else{
        await this.loadArchivedGames();
        // if player does not have any archivedGames then archivedGameData is undefined
        if (this.archivedGameData && this.archivedGameData.gameNbrMonths){
            this.currentGameMonths = this.archivedGameData.gameNbrMonths;
            this.previousGameMonths = this.archivedGameData.prevGameMonths;
            this.nbrGames = this.archivedGameData.nbrGames;
            this.setState({timeWizardLoading: false});
        }else{
            this.setState({timeWizardLoading: false});
        }
    }
     
}

loadExtraCredit()
{
    const funcName = "loadExtraCreditInfo";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.setGameInfo(true, 'extraCreditExists');
                        this.setCompletedValues(output.body);
                        this.setGameInfo(output.body, 'extraCredit');
                        if (this._isMounted === true){
                            this.setState({extraCreditLoading: false});
                        }
                    }else{
                        if (statusCode === 250){
                            if (this._isMounted === true){
                                this.setState({extraCreditLoading: false});    
                            }
                            this.setGameInfo(false, 'extraCreditExists');
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        })
}

async loadArchivedGames() {
    const funcName = "archivedGameData";
    const urlParm = "?maxNbrGames=1&rqstType=MaxNbrGames";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, {
            method: 'GET',
            headers: this.state.headers
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const output = JSON.parse(data); // keeping your JSON.parse in case data is a string
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            this.archivedGameData = output.body[0];
            if (this._isMounted) {
                this.setState({ archivedGameLoaded: true });
            }
        } else {
            const errorObj = {function: funcName, subProcess: this.state.subProcess,
                status: statusCode, message: output.body.message };
            this.props.processError(errorObj);
        }

    } catch (error) {
        const errorObj = { function: funcName, subProcess: this.state.subProcess,
            status: 'FetchError', message: error.message
        };
        this.props.processError(errorObj);
    }
}


loadTimeWizard(gameID) {
    const funcName = "loadTimeWizard";
    const urlParm = "?gameID=" + gameID;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        { method: 'GET', headers: this.state.headers })
        .then(response => {
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    let timeWizard = output.body;
                    this.determineCurrentNbrGameMonths(timeWizard);
                    this.setGameInfo(timeWizard, "timeWizardInfo");
                    this.setState({timeWizardLoading: false});
                }else{
                    if (statusCode === 250){
                           // there is no time wizard record for this player
                           this.setState({timeWizardLoading: false});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                }
            });
        });
}

determineCurrentNbrGameMonths(timeWizard){
     if (timeWizard.status !== "inactive"){
         this.totalNbrGameMonths = +timeWizard.gameNbrYears * 12;
     }
     if (this.userRole === "demo"){
        this.currentGameMonths = 0;
     }else{
        this.currentGameMonths += (this.totalNbrGameMonths - +this.gameNbrMonths);
     }
}

setCompletedValues(extraCredit){
    this.determineCompletedLevels(extraCredit);
    for (let i=0; i<this.levelCompleteArr.length; i++){
        let indx = +this.levelCompleteArr[i];
        this.inputCompleted(indx);
    }
    this.setState({inputArr: this.state.inputArr}); 
}

determineCompletedLevels(extraCredit){
    this.exerciseLevelArr = [];
    let levels = ExtraCreditConfigFile.exercises;
    let extraCreditComplete = extraCredit.extraCreditTable;
    for (let i=0; i<levels.length; i++){
         let levelsPlusComplete = {category: levels[i].category, level: levels[i].level, complete: false};
         const levelCompleteObj = extraCreditComplete.find(elem => elem.category === levels[i].category);
         if (levelCompleteObj){
            levelsPlusComplete.complete = true;
         }
         this.exerciseLevelArr.push(levelsPlusComplete);
    }
    this.exerciseLevelArr.sort((a, b) => (a.level > b.level) ? 1 : -1);
    let levelNbr = "";
    let levelComplete = false;
    this.levelCompleteArr = [];
    for (let i=0; i<this.exerciseLevelArr.length; i++){
        if (levelNbr !== this.exerciseLevelArr[i].level){
            if (levelNbr !== ""){
                 if (levelComplete === true){
                      this.levelCompleteArr.push(levelNbr);
                 }
            }
            levelComplete = true;
            levelNbr = this.exerciseLevelArr[i].level;
        }
        if (this.exerciseLevelArr[i].complete === false){
            levelComplete = false;
        }
    }
    if (levelComplete === true){
        this.levelCompleteArr.push(levelNbr);
    }
}

updateAmounts(){
    let processObj = JSON.parse(sessionStorage.getItem("extraCreditCompleted"));
    this.processName = processObj.processName;
    this.assetType = processObj.assetType;
    this.amount = processObj.amount;
    this.moodPointChange = "200";
    if (this.state.eventTracker === true && this.gameInfoDisplay.gameExists === true){
        this.addToEventArray();
    }
    if (this.assetType === "salary"){
        if (this.gameInfoDisplay.gameExists === true){
            let newAssetObj = addChangeSalaryAsset(this.gameInfoDisplay.gameData.assetTable,
                "ExtraCreditBonus", this.gameInfoDisplay.gameData.currentGameDate, this.amount,
               this.processName);
            this.gameInfoDisplay.gameData.assetTable = newAssetObj.assetTable;
            this.setGameInfo(this.gameInfoDisplay.gameData.assetTable, "gameData", "assetTable");
            this.gameInfoDisplay.gameData.currentMoodPoints = 
                    (+this.gameInfoDisplay.gameData.currentMoodPoints + +this.moodPointChange).toString();
            this.setGameInfo(this.gameInfoDisplay.gameData.currentMoodPoints, "gameData", 
                    "currentMoodPoints");
            this.newSalaryAmt = newAssetObj.totalSalary;
            // update the taxes for the new salary amount
            this.updateExpenseTable();
        }else{
            this.currentSalary = +ExtraCreditConfigFile.general.defaultSalary;
            this.newSalaryAmt = (+this.currentSalary * +this.amount).toFixed(2);
            this.newSalaryAmt = this.newSalaryAmt.toString();
        }

    }else{
        if(processObj.assetType === "cash"){
            if (this.gameInfoDisplay.gameExists === true){
                let newCashAmt = (+this.gameInfoDisplay.gameData.currentCash + +this.amount).toFixed(2)
                this.gameInfoDisplay.gameData.currentCash = newCashAmt;
                this.setGameInfo(this.gameInfoDisplay.gameData.currentCash, "gameData", "currentCash");
                this.gameInfoDisplay.gameData.currentMoodPoints = 
                    (+this.gameInfoDisplay.gameData.currentMoodPoints + +this.moodPointChange).toString();
                this.setGameInfo(this.gameInfoDisplay.gameData.currentMoodPoints, "gameData", 
                    "currentMoodPoints");
            }
        }
       
    }
    this.extraCreditObj = {category: this.processName, score: processObj.score,
        assetType: processObj.assetType, amount: processObj.amount, level: processObj.level};
    this.extraCreditCompleted.push(this.processName);
    this.addToExtraCreditTable();
    if (this.gameInfoDisplay.gameExists === true){
        let allExtraCreditComplete = false;
        if (this.gameInfoDisplay.extraCredit.user ){
            allExtraCreditComplete = 
                determineIfAllExtraCreditComplete(this.gameInfoDisplay.extraCredit.extraCreditTable);
        }
        if (allExtraCreditComplete === true){
             this.addAllCompleteCondition();
        }
        this.updateCashExpenseAsset();
    }
    if (this.gameInfoDisplay.playerRole === "demo"){
        //  do not update the extra credit table if the user role is 'demo'
    }else{
        this.updateExtraCredit();
    }
}

updateExpenseTable(){
    const taxExpenseObj = createTaxAmtExpense(this.gameInfoDisplay.gameData.expenseTable,  
            this.gameInfoDisplay.gameData.assetTable, 
            this.gameInfoDisplay.gameData.currentGameDate);
    if (this.state.eventTracker === true && this.gameInfoDisplay.gameExists === true){
        this.eventType = "TaxChange";
        let eventDetail = TaxChangeEventTracker;
        eventDetail.value = taxExpenseObj.newTaxAmt;
        eventDetail.tableItemChanged = taxExpenseObj.oldTaxExpense;
        this.saveEventTracker(eventDetail);
    }
    this.gameInfoDisplay.gameData.expenseTable = taxExpenseObj.expenseTable;
    this.setGameInfo(this.gameInfoDisplay.gameData.expenseTable, "gameData", "expenseTable");
}

addToEventArray(){
    this.eventType = "ExtraCredit";
    let category = "";
    let onItem = "";
    let type = "";
    let duration = "";
    let tableItemObj = {};
    if (this.assetType === "salary"){
        category = "salary";
        onItem = "Job Salary";
        duration = "-1";
        type = "flat";
        tableItemObj = {assetItem: "Salary Bonus - Extra Credit",  assetDesc: "Challenges Completed",
            assetAmt: "1000", assetStartDate: "2025-04", assetNbrMonths: -1};
    }else{
        category = "cash";
        onItem = "cash";
        duration = "1";
        type = "flat";
    }
    const eventObj = {category: category, on: onItem, duration: duration, value: this.amount, 
        type: type, title: this.processName, tableItemChanged: tableItemObj, 
        moodPoints: this.moodPointChange};
    this.saveEventTracker(eventObj);
}

addAllCompleteCondition(){
    const conditionExists = this.gameInfoDisplay.gameData.conditionsTable.find(elem => elem.condName ===
        "all-extra-credit-complete");
    if (!conditionExists){
        const conditionObj = {condName: "all-extra-credit-complete", conditionClass: "game"};
        this.gameInfoDisplay.gameData.conditionsTable.push(conditionObj);
        this.setGameInfo(this.gameInfoDisplay.gameData.conditionsTable, "gameData", "conditionsTable");
    }
}

updateCashExpenseAsset(){            
    const bodyObj = {"currentCash": this.gameInfoDisplay.gameData.currentCash,
                     "currentMoodPoints": this.gameInfoDisplay.gameData.currentMoodPoints,
                     "assetTable": JSON.parse(JSON.stringify(this.gameInfoDisplay.gameData.assetTable)) ,
                     "expenseTable": JSON.parse(JSON.stringify(this.gameInfoDisplay.gameData.expenseTable)),
                     "conditionsTable": JSON.parse(JSON.stringify(this.gameInfoDisplay.gameData.conditionsTable)),
                    };
    const beforeObj = this.gameInfoDisplay.gameData;
    const funcName = "updateCashAssetExpense";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {method:'PUT', headers: this.state.headers,
          body: JSON.stringify(bodyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // update was successful");
                           this.props.setInfoRedux(output.body, "gameData");
                           const afterObj = output.body;
                           const dataObj = {dataType: "gameData", beforeObject: beforeObj, 
                                afterObject: afterObj, processName: "ExtraCredit", 
                                paragraphName: "updateCashExpenseAsset"};
                            this.checkDataAccuracy(dataObj);
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: bodyObj};
                            this.processErrorReturn(errorObj);
                        }
                    });
                };
            });
}

addToExtraCreditTable(){
    if (this.gameInfoDisplay.extraCredit &&
        this.gameInfoDisplay.extraCredit.extraCreditTable ){
        //  continue, all is well
    }else{
        this.gameInfoDisplay.extraCredit.extraCreditTable = [];
    }
    this.gameInfoDisplay.extraCredit.extraCreditTable.push(this.extraCreditObj);
    
    this.determineCompletedLevels(this.gameInfoDisplay.extraCredit);
    this.setGameInfo (this.gameInfoDisplay.extraCredit, "extraCredit");
}

updateExtraCredit(){
    // Update extra credit table in Mongo
    let userName = "";
    if (this.gameInfoDisplay.gameExists === true){
        userName = this.gameInfoDisplay.gameData.user;
    }else{
        userName = sessionStorage.getItem("username");
    }
    const bodyObj = {
        "user": userName,
        "userRole": this.userRole,
        "extraCreditTable":JSON.parse(JSON.stringify(this.gameInfoDisplay.extraCredit.extraCreditTable)),
    };
    const funcName = "updateExtraCredit";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
          {method:'PUT', headers: this.state.headers,
          body: JSON.stringify(bodyObj)})
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.setGameInfo (true, "extraCreditExists");
                        this.setGameInfo (output.body, "extraCredit");
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

saveEventTracker(eventObj) {
    const dataObject = createEventTrackerUpdateObject(this.eventType, this.processName,
        this.gameInfoDisplay.gameData, eventObj, this.gameInfoDisplay.creditCardInfo);
    const funcName = "saveEventTracker";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {
        method:'post',
        headers: this.state.headers,
        body: JSON.stringify(dataObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       // save event tracker was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

getGameInfo()
{
    const gameInfo = this.props.gameInfo;
    this.setState({gameInfo: gameInfo});
    return gameInfo;
}

setGameInfo(value, propertyName = null, subPropertyName)
{ 
    if (propertyName ){
        if (subPropertyName ){
            this.props.setGameDataRedux(value, subPropertyName);
        }else{
            this.props.setInfoRedux(value, propertyName);
        }
        this.setState({gameInfo: this.props.gameInfo});
    }else{
        const errorObj={function: "SetGameInfo", subProcess: this.state.subProcess, 
            status: 999, message: "propertyName is undefined", errorObject: value,
            silentAlert: true};
        this.processErrorReturn(errorObj);
    }
} 

goToHomePage(){
    let newProcess = "";
    if (!this.gameInfoDisplay.prevProcess || this.gameInfoDisplay.prevProcess === ""){
       newProcess = "";
    }else{
        newProcess = this.gameInfoDisplay.prevProcess;
    }
    this.onNavigate(newProcess);
}

checkDataAccuracy(dataObj){
    const dataCompareObj = beforeAfterCompare(dataObj.dataType, dataObj.beforeObject, dataObj.afterObject);
    if (dataCompareObj.dataValid === false){
        const errorDataObject = {processName: dataObj.processName, paragraphName: dataObj.paragraphName, 
            dataType: dataObj.dataType, beforeObject: dataObj.beforeObject, 
            afterObject: dataObj.afterObject, dataSubTypeArr: dataCompareObj.dataSubTypeArr};
        const errorMessage = "Discrepancy found in before/after compare of redux vs. mongo.";
        this.generalErrorLog(errorMessage, errorDataObject);
    }
}

generalErrorLog(errorDesc, dataObject) {
    if (!dataObject){
        dataObject = {currentCard: "none",
            currentCash: this.gameData.currentCash,
            assetTable: this.gameData.assetTable,
            expenseTable: this.gameData.expenseTable,
            loanTable: this.gameData.loanTable,
            conditionsTable: this.gameData.conditionsTable};
    }
    const message = errorDesc;
    const errorObj={function: "GeneralError", subProcess: this.state.subProcess, 
        status: 999, message: message, errorObject: dataObject, silentAlert: true};
    this.processErrorReturn(errorObj);
}

processErrorReturn(errorObj){
    this.addRecordToLogfile(errorObj);
    if (!errorObj.silentAlert || errorObj.silentAlert === false){
        alert ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
        this.onNavigate("");
    }
}

addRecordToLogfile(errorObj){
    const headers=setHeadersForFetch();
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let subProcess = "";  
    if (!errorObj.subProcess){
        subProcess = "unknown"
    }else{
        subProcess = errorObj.subProcess;
    }
    if (!errorObj.errorObject){
        errorObj.errorObject = {};
    }
    const logFileBody =  {
        mainProcess: "ExtraCredit",
        subProcess: subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message,
        errorObj: errorObj.errorObject
    }
    console.log("logFileBody is: ", logFileBody)
    const urlParm = "";
    const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
    fetch (uri,  
        {method:'POST',
            headers: headers,
            body: JSON.stringify(logFileBody)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        console.log("Response from save log file not valid!" +
                         " status is: ", output.statusCode,
                         " message is: ", output.body);
                        alert ("Response from save log file not valid!");
                           
                    }
            });
        }
    });
  
}

}

export default connect (mapStateToProps, mapDispatchToProps) (withRouterCompat(ExtraCredit));